<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddCompte')">
        <router-link class="btn btn-primary" to="/comptes/ajouter-compte">
          <i class="fa fa-plus-circle"></i>
          Ajouter un compte
        </router-link>
      </div>
      <div class="col-md-4" v-if="point_ventes.length > 1">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Filtrer par Point de vente
          </label>
          <div class="d-flex align-items-center" style="width: 200px;">
            <Multiselect v-model="point_vente" :options="point_ventes" :searchable="true" track-by="label" label="label"
              placeholder="Sélectionner un point de vente" />
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher un compte" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Numero de compte
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                INTITULÉ
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                SOLDE INITIAL
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                SOLDE ACTUEL
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                TYPE DE COMPTE
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Plafond
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(compte, index) in comptes" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ compte.numero }}
              </td>
              <!--<td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{
                  compte?.client.nomClient && compte?.client.prenomClient
                    ? `${compte?.client.nomClient} ${compte?.client.prenomClient}`
                    : compte?.client.raisonSociale
                }}
              </td>-->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ compte.intituleCompte }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(compte.soldeInitial) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(compte.soldeActuel) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getTypeCompteLabel(compte.typeCompte) }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(compte.plafond) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu dropdown-block">
                    <li class="dropdown-item d-flex align-items-center">
                      <a href="#"
                        data-bs-toggle="modal" 
                        data-bs-target="#AddPlafondModal" 
                        @click="openAddPlafondModal(compte)">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                       Réajuster le plafond
                      </a>
                    </li>
                    <li v-if="checkPermission('EditCompte')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(compte.id, comptes, 'comptes', `le compte ${compte.id}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddPlafondModal :selectedCompte="selectedCompte" @close="recharger"/>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Compte } from "@/models/Compte";
import ApiService from "@/services/ApiService";
import { suppression, error, separateur } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import AddPlafondModal from "./AddPlafondModal.vue";


export default defineComponent({
  name: "ListeCompte",
  components: {
    PaginationComponent,
    Multiselect,
    AddPlafondModal
  },
  setup() {
    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllComptes(point_vente.value);
    });

    const comptes = ref<Array<Compte>>([]);
    const compte = ref<Compte>();
    const selectedCompte = ref<Compte | undefined>(undefined);
    const selectedCompteId = ref<number>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllComptes(page_, limit_);
      } catch (error) {
        //
      }
    };

     const openAddPlafondModal = (compte: Compte) => {
      selectedCompte.value = { ...compte };
      selectedCompteId.value = compte.id;
      console.log('compte selected ', selectedCompte.value);
    };

    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllComptes(point_vente.value, page.value, limit.value, searchTerm.value);
    }


    const recharger = () => {
        getAllComptes(point_vente.value, page.value, limit.value, searchTerm.value);
      };


    // END PAGINATE

    // Mapping des types de compte
    const typeCompteLabels: { [key: string]: string } = {
      '1': 'Compte Comptant',
      '2': 'Compte Créance',
      '3': 'Compte Dépot-Vente',
    };

    // Fonction pour obtenir le label du type de compte
    const getTypeCompteLabel = (typeCompte: string) => {
      return typeCompteLabels[typeCompte] || 'Type inconnu';
    };

    function getAllComptes(point_vent, page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/comptes?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          comptes.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function moddifier(Editcomptes: Compte) {
      compte.value = Editcomptes;
    }

    const deleteCompte = (id: number) => {
      ApiService.delete(`/comptes/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false,
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réessayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < comptes.value.length; i++) {
        if (comptes.value[i].id === id) {
          comptes.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    return {
      comptes,
      checkPermission,
      getAllComptes,
      deleteCompte,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      separateur,
      searchTerm,
      getTypeCompteLabel,
      point_ventes,
      recharger,
      selectedCompteId,
      selectedCompte,openAddPlafondModal
    };
  },
});
</script>